window.prototype = this;

openPopUpConfirm = function ($event, $title, $text, $icon, $confirmButtonText, $cancelButtonText ) {
    Swal.fire({
        title: $title,
        text: $text,
        icon: $icon,
        showCancelButton: $cancelButtonText ? true : false,
        confirmButtonColor: '#3C8DBC',
        cancelButtonText: $cancelButtonText,
        confirmButtonText: $confirmButtonText
    }).then((result) => {
        if (result.isConfirmed) {
            $($event.target.parentNode).find('form').submit();
        }
    });
};

openPopUpConfirmAsync = function ($event, $title, $text, $icon, $confirmButtonText, $cancelButton= false) {
    Swal.fire({
        title: $title,
        text: $text,
        icon: $icon,
        showCancelButton: $cancelButton,
        confirmButtonColor: '#3C8DBC',
        cancelButtonText: $cancelButtonText,
        confirmButtonText: $confirmButtonText
    }).then((result) => {
        if (result.isConfirmed) {
            $($event.target.parentNode).find('.btn-form').click();
        }
    });
};

openPopUpHtmlText = function ($event, $title, $html, $icon, $confirmButtonText, $cancelButtonText) {
    Swal.fire({
        allowOutsideClick: false,
        allowEscapeKey: false,
        title: $title,
        html: $html,
        icon: $icon,
        showConfirmButton: $confirmButtonText ? true : false,
        showCancelButton: $cancelButtonText ? true : false,
        confirmButtonColor: '#3C8DBC',
        cancelButtonText: $cancelButtonText,
        confirmButtonText: $confirmButtonText
    }).then((result) => {
        if (result.isConfirmed) {
            $($event.target.parentNode).find('form').submit();
        }
    });
}
